import store from '@/store';
import BasePerimeter from './basePerimeter';

const infoWhitelist = ['pending_err', 'pending_requested', 'edb_accepted', 'edb_rejected', 'pending_edb', 'edb_request'];
const ERRWhitelist = ['pending_err', 'pending_requested', 'edb_accepted', 'edb_rejected', 'pending_edb'];

export default new BasePerimeter({
  purpose: 'actions',
  govern: {
    'can viewAdmin': function viewAdmin() {
      return this.isAdmin();
    },
    'can viewCRM': function viewCRM() {
      return this.isCRM();
    },
    'can viewERR': function viewERR() {
      return this.isERR() || this.isFDP();
    },
    'can viewFDP': function viewFDP() {
      return this.isFDP();
    },
    'can makeInfoRequest': function makeInfoRequest() {
      const currentState = store.getters.selected.aasm_state;
      const currentCategory = store.getters.selected.category;
      return (this.isERR() || this.isFDP()) &&
             infoWhitelist.includes(currentState) &&
             currentCategory !== -1;
    },
    'can approveReimbursement': function approveReimbursement() {
      const currentState = store.getters.selected.aasm_state;
      return (this.isERR() || this.isFDP()) && ERRWhitelist.includes(currentState);
    },
    'can closeComplaint': function closeComplaint() {
      const currentState = store.getters.selected.aasm_state;
      return (this.isERR() || this.isFDP()) && ERRWhitelist.includes(currentState);
    },
    'can rejectComplaint': function rejectComplaint() {
      const currentState = store.getters.selected.aasm_state;
      return (this.isERR() || this.isFDP()) && ERRWhitelist.includes(currentState);
    },
    'can sendToEDB': function sendToEDB() {
      return this.isERR() && ['pending_err'].includes(store.getters.selected.aasm_state) && store.getters.selected.category !== -1;
    },
    'can requestInfo': function requestInfo() {
      return this.isCRM() && store.getters.selected.aasm_state === 'pending_info';
    },
    'can notifyApproval': function notifyApproval() {
      return this.isCRM() && ['approved_communication'].includes(store.getters.selected.aasm_state);
    },
    'can notifyRejection': function notifyRejection() {
      return this.isCRM() && ['rejected_communication'].includes(store.getters.selected.aasm_state);
    },
    'can resendERR': function resendERR() {
      return this.isCRM() && ['pending_requested'].includes(store.getters.selected.aasm_state);
    },
    'can reimburse': function reimburse() {
      return this.isFDP() && store.getters.selected.aasm_state === 'approved_reimbursement';
    },
    'can deleteAttachment': function deleteAttachment() {
      return this.isERR() || this.isAdmin();
    },
    'can viewAll': function viewAll() {
      return this.isERR();
    },
  },
  getActivityAction() {
    return this.isERR() ? 'complaint_err_request' : 'complaint_crm_request';
  },
  expose: [
    'getActivityAction',
  ],
});



// WEBPACK FOOTER //
// ./src/perimeters/actionsPerimeter.js